<div class="card bg-dark-lighter text-white fx-cms-kyc" id="list-kyc">
  <div class="card-header">
    <div class="row">
      <div class="col  m-auto">
        {{ "KYC Approve" | uppercase }}
      </div>
      <div class="col-auto">
        <!--<button class="btn btn-primary" (click)="navigateTo('list-credit-Card')">-->
          <!--{{ "Credit Card Approve" }}-->
        <!--</button>-->
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="row mb-3">
      <div class="col-md-6">
        <div class="input-group search-group">
          <input
            type="text"
            class="form-control bg-dark"
            name="keyword"
            placeholder="username, email"
            [(ngModel)]="condition.keyword"
            (keyup)="onKeyup($event)"
          />
          <div class="input-group-append">
            <button
              class="btn btn-main"
              type="button"
              (click)="searchKyc()"
            >
              Search
            </button>
            <button
              class="btn btn-main"
              type="button"
              (click)="condition.keyword = ''; getListKyc();"
            >
              Refresh
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-xs-12">
        <div class="table-responsive">
          <table class="rox-table table-bordered bg-dark">
            <thead>
            <tr>
              <th class="text-center" colspan="6">INFORMATION</th>
              <th class="text-center" colspan="3">KYC DOCUMENT</th>
              <th class="text-center" rowspan="2" create-permission>View KYC</th>
              <th class="text-center" rowspan="2" create-permission></th>
              <th class="text-center" rowspan="2">Comment</th>
            </tr>
            <tr>
              <th class="text-center">ID</th>
              <th class="text-center">
                Status
                <select [(ngModel)]="condition.kycCode" (change)="searchKyc()">
                  <option value="">All</option>
                  <option *ngFor="let kyc of listKYCStatus; let i = index" value="{{kyc[0]}}">
                    {{kyc[1]}}
                  </option>
                </select>
              </th>
              <th class="text-center">UserName</th>
              <th class="text-center">UserName(JP)</th>
              <th class="text-center">Email</th>
              <th class="text-center sortable" (click)="sorting('country')">
                Country
                <i
                  class="fa fa-{{
                        condition.orderBy === 'country'
                          ? sort.country === 'asc'
                            ? 'sort-asc'
                            : 'sort-desc'
                          : 'sort'
                      }}"
                ></i>
              </th>
              <th class="text-center mw-130">ID</th>
              <th class="text-center mw-130">ID On</th>
              <th class="text-center mw-130">Address</th>
            </tr>
            </thead>
            <tbody>
              <tr
              *ngFor="
                          let item of listKycs
                            | paginate
                              : {
                                  id: 'cmsKyc',
                                  itemsPerPage: pageInfo.pageSize,
                                  currentPage: pageInfo.pageIndex,
                                  totalItems: pageInfo.totalRecord
                                };
                          let i = index
                        ">
              <td class="text-center">{{item.id}}</td>
              <td class="text-center">
                <span [innerHtml]="item.getStatusKyc()"></span>
              </td>
              <td class="text-center">{{item.getUsername()}}</td>
              <td class="text-center">{{item.getUsernameJP()}}</td>
              <td class="text-center">{{item.email}}</td>
              <td class="text-center">{{getCountryNameByCode(item.country)}}</td>
              <td class="text-center action-process">
                <div class="action-process__view {{(item.idStatus == -1) ? 'unupload' : ''}}">
                  <span [innerHtml]="getLabelStatusKyc(item.idStatus)">
                  </span>
                  <!--<i *ngIf="item.idStatus > -1" class="fa fa-eye"(click)="openImages(item, 'id')" create-permission></i>-->
                </div>
                <div class="action-process__status" create-permission>
                  <ng-container *ngIf="item.idStatus == 0">
                    <button class="btn btn-down" type="button" (click)="onChangeKycProcess('id_status', item.id, 2, i)">Reject</button>
                    <button class="btn btn-up" type="button"
                            (click)="onChangeKycProcess('id_status', item.id, 1, i)">Approval</button>
                  </ng-container>
                  <ng-container *ngIf="item.idStatus == 1">
                    <button class="btn btn-down" type="button" (click)="onChangeKycProcess('id_status', item.id, 2, i)">Reject</button>
                    <button class="btn btn-up" type="button"
                            (click)="onChangeKycProcess('id_status', item.id, 0, i)">Pending</button>
                  </ng-container>
                  <ng-container *ngIf="item.idStatus == 2">
                    <button class="btn btn-down" type="button" (click)="onChangeKycProcess('id_status', item.id, 1, i)">Verify</button>
                    <button class="btn btn-up" type="button"
                            (click)="onChangeKycProcess('id_status', item.id, 0, i)">Pending</button>
                  </ng-container>
                </div>
              </td>
              <td class="text-center action-process">
                <div class="action-process__view {{(item.handStatus == -1) ? 'unupload' : ''}}">
                  <span [innerHtml]="getLabelStatusKyc(item.handStatus)"></span>
                  <!--<i class="fa fa-eye" *ngIf="item.handStatus > -1" (click)="openImages(item, 'hand')" create-permission></i>-->
                </div>
                <div class="action-process__status" create-permission>
                  <ng-container *ngIf="item.handStatus == 0">
                    <button class="btn btn-down" type="button" (click)="onChangeKycProcess('selfie_status', item.id, 2, i)">Reject</button>
                    <button class="btn btn-up" type="button"
                            (click)="onChangeKycProcess('selfie_status', item.id, 1, i)">Approval</button>
                  </ng-container>
                  <ng-container *ngIf="item.handStatus == 1">
                    <button class="btn btn-down" type="button" (click)="onChangeKycProcess('selfie_status', item.id, 2, i)">Reject</button>
                    <button class="btn btn-up" type="button"
                            (click)="onChangeKycProcess('selfie_status', item.id, 0, i)">Pending</button>
                  </ng-container>
                  <ng-container *ngIf="item.handStatus == 2">
                    <button class="btn btn-down" type="button" (click)="onChangeKycProcess('selfie_status', item.id, 1, i)">Verify</button>
                    <button class="btn btn-up" type="button"
                            (click)="onChangeKycProcess('selfie_status', item.id, 0, i)">Pending</button>
                  </ng-container>
                </div>
              </td>
              <td class="text-center action-process">
                <div class="action-process__view {{(item.addressStatus == -1) ? 'unupload' : ''}}">
                  <span [innerHtml]="getLabelStatusKyc(item.addressStatus)"></span>
                  <!--<i class="fa fa-eye" *ngIf="item.addressStatus > -1" (click)="openImages(item, 'address')" create-permission></i>-->
                </div>

                <div class="action-process__status" create-permission>
                  <ng-container *ngIf="item.addressStatus == 0">
                    <button class="btn btn-down" type="button" (click)="onChangeKycProcess('address_status', item.id, 2, i)">Reject</button>
                    <button class="btn btn-up" type="button"
                            (click)="onChangeKycProcess('address_status', item.id, 1, i)">Approval</button>
                  </ng-container>
                  <ng-container *ngIf="item.addressStatus == 1">
                    <button class="btn btn-down" type="button" (click)="onChangeKycProcess('address_status', item.id, 2, i)">Reject</button>
                    <button class="btn btn-up" type="button"
                            (click)="onChangeKycProcess('address_status', item.id, 0, i)">Pending</button>
                  </ng-container>
                  <ng-container *ngIf="item.addressStatus == 2">
                    <button class="btn btn-down" type="button" (click)="onChangeKycProcess('address_status', item.id, 1, i)">Verify</button>
                    <button class="btn btn-up" type="button"
                            (click)="onChangeKycProcess('address_status', item.id, 0, i)">Pending</button>
                  </ng-container>
                </div>
              </td>
              <td class="text-center">
                <i *ngIf="item.status !== -1" class="fa fa-eye"(click)="getAllImageKyc(item)" create-permission></i>
              </td>
              <td class="text-center" create-permission>
                <a
                  href="javascript:void(0)"
                  class="text-blue-lighter"
                  (click)="getKycDetail(item)"
                  data-bs-toggle="modal"
                  data-bs-target="#modalKYCDetail"
                >View</a
                >
              </td>
              <td class="text-center">
                <textarea *ngIf="isEdit && currentIndexEdit == item.id"
                          rows="3" [(ngModel)]="item.comment"></textarea>
                <div class="fs-18  fx-cms-kyc-comment" *ngIf="!isEdit || currentIndexEdit != item.id">{{item.comment}}</div>
                <i class="fa fa-save" *ngIf="isEdit && currentIndexEdit == item.id" (click)="onSave(item)"></i>
                <i class="fa fa-edit" *ngIf="!isEdit || currentIndexEdit != item.id" (click)="onEdit(item)"></i>
                <i class="fa fa-ban" *ngIf="isEdit && currentIndexEdit == item.id" (click)="onEdit(null)"></i>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row mt-15">
      <div class="col">
        <div class="pagination-wrapper">
          <pagination-controls
            id="cmsKyc"
            (pageChange)="pageChanged($event)"
            autoHide="true"
            responsive="true"
            previousLabel="Prev"
            nextLabel="Next"
          >
          </pagination-controls>
        </div>
        <div class="ml-5" *ngIf="pageInfo.totalRecord > pageInfo.pageSize">
          <span>Page</span>
          <input
            class="ml-2"
            type="number"
            name="pageIndex"
            [(ngModel)]="pageInfo.pageManual"
            (keyup)="onKeyupPage($event)"
          />
          <button class="btn btn-primary ml-2" style="padding: 2px .75rem;"
                  (click)="pageChanged(pageInfo.pageManual)">
            Go
          </button>
        </div>
      </div>
      <div class="col-auto">
            <span class="data-info "
            >Found: {{ pageInfo.totalRecord }}
              {{ pageInfo.totalRecord > 1 ? "records" : "record" }}</span
            >
      </div>
    </div>
  </div>
  <fx-lightbox #lightbox></fx-lightbox>
  <div class="modal fade fx-modal" id="modalKYCDetail">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-shadow">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h2 class="modal-title font-bold" style="margin-bottom: 0">
            {{ kycDetail.email + ' (' +  kycDetail.getUsername() + ')' }}
          </h2>
          <button
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            &times;
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <table class="rox-table table-bordered bg-dark" *ngIf="kycDetail">
            <tbody>
            <tr>
              <td class="text-center text-main">Phone</td>
              <td class="text-start">{{ kycDetail.phone }}</td>
            </tr>
            <tr>
              <td class="text-center text-main">Date Of Birthday</td>
              <td class="text-start">{{ kycDetail.dob | date: 'dd/MM/yyyy' }}</td>
            </tr>
            <tr>
              <td class="text-center text-main">Country</td>
              <td class="text-start">
                {{getCountryNameByCode(kycDetail.country)}}
              </td>
            </tr>
            <tr>
              <td class="text-center text-main">Postal/Zip Code</td>
              <td class="text-start">{{ kycDetail.zipCode }}</td>
            </tr>
            <tr>
              <td class="text-center text-main">Province/City</td>
              <td class="text-start">{{ kycDetail.city }}</td>
            </tr>
            <tr>
              <td class="text-center text-main">Street</td>
              <td class="text-start">{{ kycDetail.street }}</td>
            </tr>
            <tr>
              <td class="text-center text-main">Address</td>
              <td class="text-start">{{ kycDetail.address }}</td>
            </tr>
            <tr>
              <td class="text-center text-main">Building</td>
              <td class="text-start">{{ kycDetail.building }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
